<div class="shareContainer">

  <div class="shareModalBox" [ngClass]="{'lowCoins': userData?.coins < 5, 'highCoins': userData?.coins >= 5}">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="imgDiv">
      <img class="vegboost-logo" [src]="srcIconBoost" alt="VegBoost" (error)="onImageError($event)">
    </div>
    <span class="title-share">{{'vegBoost' | translate}}</span>


    <div class="txt-question">
      {{'highlightProfile' | translate}}
    </div>
    <div class="txt-description">
      {{'activateVegBoost' | translate }} <b>12 {{'hours' | translate}}</b>
    </div>
    <br>
    <ion-button class="boostButton button-round" *ngIf="userData?.coins >= 5" (click)="boostMe()">
      {{'boostMe' | translate}}
    </ion-button>
    <ion-button class="purchaseButton button-round" *ngIf="userData?.coins < 5" (click)="openCurrency('VegBoost')">
      {{'buyCarrots' | translate}}
    </ion-button>
    <span class="youOwnClass" [ngClass]="{'lowCoins': userData?.coins < 5, 'highCoins': userData?.coins >= 5}">
      {{ 'youOwn' | translate }} {{ userData?.coins }} {{ 'carrots' | translate }}
    </span>
  </div>
</div>